import {callBackendApi} from "../../../components/service/axios";
import {InformationAssetUser} from "../models/information-asset-user";

export const fetchInformationAssetUsers = async ( emailList: string[] ): Promise<InformationAssetUser[]> => {
    return await callBackendApi("post", "/bff/information-asset-users", {emails: emailList});
};